import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { readString } from "react-papaparse";
import ResultModal from "./ResultModal";
import * as XLSX from "xlsx";

const CsvImportPartner = ({ setResult }) => {
  const { t: translator } = useTranslation();

  const inputFile = React.useRef(null);

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const handleImportFileClick = () => {
    inputFile.current.click();
  };

  const allowDrop = (e) => {
    e.preventDefault();
  };

  const dropHandler = (ev) => {
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      if (ev.dataTransfer.items.length > 1) {
        setModal({
          show: true,
          title: "Greška!",
          text: "Dozvoljen uvoz samo jedne datoteke istovremeno!",
          btnClass: "btn btn-danger",
        });
        return;
      }
      // Use DataTransferItemList interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them

        if (ev.dataTransfer.items[i].kind === "file") {
          var x = ev.dataTransfer.items[i].getAsFile();
          const fileExt = x.name.split(".").pop();

          if (!["csv", "xlsx", "xls"].includes(fileExt)) {
            setModal({
              show: true,
              title: "Greška!",
              text: "Format datoteke nije ispravan! Podržani format datoteke je csv.",
              btnClass: "btn btn-danger",
            });
          } else {
            handleUploadFile(x);
          }
        }
      }
    }

    ev.target.value = "";
  };

  const showFile = async (e) => {
    let x = e.target.files[0];
    handleUploadFile(x);
    e.target.value = "";
  };

  const handleUploadFile = (x) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      // Now you have access to the sheet data, you can parse and process it here
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      const headers = XLSX.utils.sheet_to_json(sheet, { header: 1 })[0];
      setResult({ data: jsonData, meta: { fields: headers || [] } });
      // setResult(
      //   readString(e.target.result, {
      //     header: true,
      //     skipEmptyLines: true,
      //     dynamicTyping: true,
      //     encoding: "UTF-8",
      //   })
      // );
    };

    // reader.readAsText(x);
    reader.readAsArrayBuffer(x);
  };

  const handleClose = () => {
    setModal({ show: false });
  };

  return (
    <>
      <div
        className="csv-import-container"
        onDrop={dropHandler}
        onDragOver={allowDrop}
      >
        {translator("CsvImport-Text")} <br />
        <button className="btn btn-primary" onClick={handleImportFileClick}>
          {translator("CsvImport-Btn-ChooseFile")}
        </button>
      </div>
      <input
        type="file"
        accept=".csv, .xlsx, .xls"
        id="file"
        ref={inputFile}
        onChange={showFile}
        style={{ display: "none" }}
      />
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </>
  );
};

export default CsvImportPartner;
